import { IsBoolean } from "class-validator";

export class AdminUpdateUserResult {
    @IsBoolean()
    success: boolean
}